import { useAppDispatch } from '~/store/appDispatch.ts';
import { useEffect, useState } from 'react';
import { ContactInformationForm } from '~/modules/remote-banking-contacts/ContactInformation/ContactInformationForm.tsx';
import SuccessModal from '~/components/modals/SuccessModal/SuccessModal.tsx';
import { useNavigate } from 'react-router';
import { contactInformationFormForm } from '~/store/remote-banking-contacts/thunks/contactInformationThunks.ts';
import { TApplicationsContactInformationForm } from '~/store/remote-banking-contacts/types.ts';
import { infoMessages } from '~/constants/infoMessages.ts';
import { errorMessages } from '~/constants/errorMessages.ts';
import { useSelector } from 'react-redux';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';
import ModalAlert from '~/components/modals/ModalAlert/ModalAlert';
import { setRemoteBankingContactsError } from '~/store/remote-banking-contacts/slices.ts';
import { Box } from '@mui/material';
import { styles } from '~/modules/styles.ts';
import { FormProvider } from 'react-hook-form';
import { useApplicationsContactInformationForm } from '~/modules/remote-banking-contacts/hooks/useHookForms.ts';
import { HeaderBlock } from '~/components/HeaderFooter/HeaderBlock.tsx';
import { FooterBlock } from '~/components/HeaderFooter/FooterBlock.tsx';
import { TITLE_TEXT } from '~/modules/remote-banking-contacts/constants.tsx';
import {
  selectErrorRemoteBankingContacts,
  selectIsLoadingRemoteBankingContacts,
} from '~/store/remote-banking-contacts/selectors.ts';

const ContactInformation = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isLoading = useSelector(selectIsLoadingRemoteBankingContacts);
  const error = useSelector(selectErrorRemoteBankingContacts);
  const form = useApplicationsContactInformationForm();

  const [modalSuccessText, setModalSuccessText] = useState('');

  const handleBack = () => navigate('/');
  const closeAlertModal = () => {
    error && dispatch(setRemoteBankingContactsError(''));
  };

  const onSubmit = async (values: TApplicationsContactInformationForm) => {
    const data: TApplicationsContactInformationForm = {
      email: values.email,
      phoneNumber: values.phoneNumber,
    };

    try {
      await dispatch(contactInformationFormForm(data));
      setModalSuccessText(infoMessages.MESSAGE_APPLICATION_CREATED);
    } catch (err) {
      dispatch(setRemoteBankingContactsError(errorMessages.SERVICE_UNAVAILABLE));
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit((values) =>
          onSubmit(values as TApplicationsContactInformationForm)
        )}
      >
        <HeaderBlock titleText={TITLE_TEXT} />
        <Box sx={styles.pageContainer}>
          <Box sx={styles.formWrapper}>
            <ContactInformationForm />
          </Box>
        </Box>
        <FooterBlock />

        <SuccessModal
          isOpen={!!modalSuccessText}
          text={modalSuccessText}
          onClose={handleBack}
          showButton
          buttonValue={'Готово'}
          dataTestId="modalSuccess"
        />

        {isLoading && <FullPageLoader />}
        {!!error && <ModalAlert isOpen={!!error} text={error} onClose={closeAlertModal} />}
      </form>
    </FormProvider>
  );
};

export default ContactInformation;
